<template>
    <div id="app">
      <PopulationDisplay />
    </div>
  </template>
  
  <script>
  import PopulationDisplay from '../components/PopulationDisplay.vue';
  
  export default {
    name: 'App',
    components: {
      PopulationDisplay,
    },
  };
  </script>
  